<template>
  <div class="right_top">
    <div class="right_top__close global_pointer" @click.stop="close">
      <img :src="require('@/assets/imgs/room/room_close.png')" />
    </div>
    <!-- <div class="right_top__profile" @click.stop="toProfile">
      <img :src="require('@/assets/imgs/room/profile.png')" />
    </div> -->
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      let lastTab = this.$store.state.home.lastTab
      if (this.$store.state.home.lastId && this.$store.state.home.lastPosition) {
        this.$route.params.roomback = 1
      }
      this.$store.commit("video/updateRoomVideoList", []);
      this.$store.commit("video/updateRoomPageNum", 1);
      this.$store.commit("video/updateRoomIsHasNext", true);
      this.$store.commit("video/resetRoomCurrentIndex", 0);
      this.$store.commit("video/updateRoomStatus", 2);
      this.$router.replace({path: `/app/home/${lastTab}`, query: this.$route.query})
    },
    toProfile() {
      this.$router.push({path: "/app/profile", query: this.$route.query})
    }
  }
}
</script>

<style lang="less" scoped>
.right_top {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  >div {
    width: 28px;
    height: 28px;
    // border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: rgba(47, 47, 47, 0.5);
  }
  &__close>img {
    width: 22px;
    height: 22px;
  }
  &__profile>img {
    width: 22px;
    height: 22px;
  }
}
</style>